import { Col, Image, Row } from "antd";
import { Dispatch, SetStateAction } from "react";
import { G_Button } from "../../Button";
import G_Div from "../../Containers/G_Div";
import { SmallSpinLoader } from "../../Loaders/Loaders";
import { G_Text } from "../../Text";
import SingleNotificationItem from "./SingleNotificationItem";
import { useHandleNotificationQuery } from "./hooks";

/**
 * @since December 2023
 * @author Issa Jean Marie <jeanmarieissa@gmail.com>
 * @see {@link https://issadevs.com} - Author's website
 * @returns {JSX.Element}
 */

const NotificationOverlay = ({
  setIsNotificationOpen
}: {
  setIsNotificationOpen: Dispatch<SetStateAction<boolean>>;
}): JSX.Element => {
  const {
    setCurrentPage,
    currentPage,
    isLoadingMore,
    setIsLoadingMore,
    isFetching,
    alerts,
    data
  } = useHandleNotificationQuery();

  const handlePagination = () => {
    setCurrentPage(currentPage + 1);
    setIsLoadingMore(true);
  };

  const showPagination =
    currentPage + 1 < (data?.payload?.page?.totalPages ?? 0) ||
    (isLoadingMore &&
      isFetching &&
      currentPage + 1 <= (data?.payload?.page?.totalPages ?? 0));

  return (
    <G_Div className="bg-white shadow-md w-[600px] rounded  flex flex-col">
      <Row justify="space-between" align="middle" className="p-8 border-b">
        <Col>
          <G_Text dimension="medium" weight="bold">
            {alerts?.length ?? 0} NEW NOTIFICATIONS
          </G_Text>
        </Col>

        <Col>
          <Image
            width={14}
            src="/icons/close-black.svg"
            preview={false}
            alt=""
            onClick={() => setIsNotificationOpen(false)}
            className="cursor-pointer"
          />
        </Col>
      </Row>

      {isFetching && !isLoadingMore ? (
        <G_Div className="h-[200px] flex items-center justify-center">
          <SmallSpinLoader />
        </G_Div>
      ) : (
        <G_Div className="max-h-[600px] overflow-hidden overflow-y-auto">
          {alerts?.map((alert) => (
            <SingleNotificationItem
              setIsNotificationOpen={setIsNotificationOpen}
              key={alert.id}
              alert={alert}
            />
          ))}
        </G_Div>
      )}

      {showPagination && (
        <G_Div className="flex items-center justify-center p-8 py-4 border-t">
          <G_Button
            type="text"
            dimension="caption"
            color="ox_2_black"
            onClick={handlePagination}
            loading={isLoadingMore && isFetching}
            uppercase={false}
            pointer
            underline
            className="flex items-center gap-4"
          >
            <G_Text
              className="font-normal"
              dimension="caption"
              underline
              pointer
            >
              Load more notifications
            </G_Text>
          </G_Button>
        </G_Div>
      )}
    </G_Div>
  );
};

export default NotificationOverlay;
